export const FIREBASE_AUTH_REQUIRED_ERROR = 'Firebase authentication is required'

export const requiredFirebaseAuthHeaders = async tokenProvider => {
  const token = await tokenProvider()
  if (typeof token !== 'string' || token.length === 0 || /\s/.test(token)) {
    throw new Error(FIREBASE_AUTH_REQUIRED_ERROR)
  }
  return { Authorization: 'Bearer ' + token }
}
